var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("activity-emotion-space-section1", { ref: "section1" }),
        _c("activity-emotion-space-section2", { ref: "section2" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }